import type { Variants } from 'motion/react';

export const EASE_OUT: [number, number, number, number] = [0.215, 0.61, 0.355, 1];
export const EASE_IN_OUT: [number, number, number, number] = [0.645, 0.045, 0.355, 1];
export const LIST_SPRING = {
  type: 'spring' as const,
  stiffness: 320,
  damping: 20,
  mass: 0.8,
};

export const MOTION_DURATION = {
  micro: 0.16,
  standard: 0.22,
  drawer: 0.26,
  stagger: 0.035,
} as const;

export const getListContainerVariants = (reduceMotion: boolean): Variants =>
  reduceMotion
    ? {
        hidden: { opacity: 1, y: 0 },
        visible: { opacity: 1, y: 0 },
      }
    : {
        hidden: { opacity: 0, y: 10 },
        visible: {
          opacity: 1,
          y: 0,
          transition: {
            duration: MOTION_DURATION.standard,
            ease: EASE_OUT,
            staggerChildren: MOTION_DURATION.stagger,
          },
        },
      };

export const getListItemVariants = (reduceMotion: boolean): Variants =>
  reduceMotion
    ? {
        hidden: { opacity: 1, y: 0 },
        visible: { opacity: 1, y: 0 },
      }
    : {
        hidden: { opacity: 0, y: 8 },
        visible: {
          opacity: 1,
          y: 0,
          transition: { duration: MOTION_DURATION.micro, ease: EASE_OUT },
        },
      };
